export { Partners as default } from "./partners";
